import { makeCloudFunction } from "../makeCloudFunction";
import { SearchTicketsRequest, SearchTicketsResponse } from "@functions-types";

export const searchTickets = makeCloudFunction<
  SearchTicketsRequest,
  SearchTicketsResponse
>("ticket", "searchTickets");
